"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsButton = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

require("./Buttons.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const SettingsButton = _ref => {
  let {
    open,
    setOpen,
    transitionTime = 300,
    stageDelay = 100,
    color = 'white',
    backgroundColor,
    styles,
    className,
    rounding = 7
  } = _ref;
  const [randomId] = (0, _react.useState)(Math.random());
  const rArray = open ? [0, 0] : [20, 35];

  const getRekt = (deg, animate) => /*#__PURE__*/_react.default.createElement("rect", {
    style: {
      transitionProperty: 'x, width',
      transitionDuration: "".concat(transitionTime, "ms, ").concat(transitionTime, "ms"),
      transitionDelay: open ? '' : "".concat(stageDelay, "ms, ").concat(stageDelay, "ms")
    },
    x: animate && open ? 40 : 0,
    y: "41",
    height: "18",
    fill: color,
    width: animate && open ? 20 : 100,
    transform: "rotate(".concat(deg, " 50 50)"),
    rx: rounding
  });

  const getCircle = (r, c) => /*#__PURE__*/_react.default.createElement("circle", {
    style: {
      transitionProperty: 'r',
      transitionDuration: "".concat(transitionTime, "ms"),
      transitionDelay: open ? "".concat(stageDelay, "ms") : ''
    },
    fill: c !== null && c !== void 0 ? c : 'black',
    cx: "50",
    cy: "50",
    r: r
  });

  return /*#__PURE__*/_react.default.createElement("button", {
    className: "settingsButton styleOverride ".concat(className),
    onClick: () => {
      setOpen(!open);
    },
    style: _objectSpread(_objectSpread({}, styles), {}, {
      backgroundColor
    })
  }, /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "gearMask".concat(randomId)
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "0",
    y: "0",
    height: "100",
    width: "100",
    fill: "white"
  }), getCircle(rArray[0])), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#gearMask".concat(randomId, ")"),
    id: "settingsButtonShapes"
  }, getRekt(0, true), getRekt(45), getRekt(90, true), getRekt(135), getCircle(rArray[1], color))));
};

exports.SettingsButton = SettingsButton;